import React from 'react';
import Layout from '../Layout';
import Hero from '../Hero';
import './Home.css';

export default () => (
  <Layout>
    <div>
      <Hero />
    </div>
  </Layout>
);
